const environment = {
  API:  `${process.env.REACT_APP_PHP_SYSTEM_PROD}api`,
  SERVER: `${process.env.REACT_APP_PHP_SYSTEM_PROD}`,
};
export default environment;